export const PencomConstants = {
  AUTH_ERROR_MSG: "You are not authorized to access this page",
  GROUP_LIFE_PROVIDERS: [
    {
      id: "axamansard",
      name: "AXA Mansard Insurance Plc",
      description:
        "AXA Mansard Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "PLOT 1412, AHMADU BELLO WAY, VICTORIA ISLAND, LAGOS",
      website: "https://axamansard.com/",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "african-alliance",
      name: "African Alliance Insurance Company Ltd",
      description:
        "African Alliance Insurance Company Ltd offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "aiico",
      name: "AIICO Insurance Plc",
      description:
        "AIICO Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "alliance-general",
      name: "Alliance & General Insurance Plc",
      description:
        "Alliance & General Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "anchor",
      name: "Anchor Insurance Company Ltd",
      description:
        "Anchor Insurance Company Ltd offers comprehensive group life insurance solutions designed to protect employees and their families while helping employers meet regulatory requirements.",
      address: "Plot 5A, Ayo Jagun Street, Lekki Phase 1, Lagos",
      website: "www.anchorinsurance.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-asset-management",
      name: "Capital Express Asset Management Limited",
      description:
        "Capital Express Asset Management Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-general",
      name: "Capital Express General Insurance Limited",
      description:
        "Capital Express General Insurance Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-global-trustees",
      name: "Capital Express Global Trustees Limited",
      description:
        "Capital Express Global Trustees Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express",
      name: "Capital Express Indemnity Insurance Ltd",
      description:
        "Capital Express Indemnity Insurance Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
      address:
        "17, Bishop Kale Close, off Kasumu Ekemode Street, Victoria Island, Lagos",
      website: "www.ceiil.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-life",
      name: "Capital Express Life Assurance Limited",
      description:
        "Capital Express Life Assurance Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-pension",
      name: "Capital Express Pension Limited",
      description:
        "Capital Express Pension Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "capital-express-securities",
      name: "Capital Express Securities LTD",
      description:
        "Capital Express Securities LTD offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "chi-life",
      name: "CHI Life Assurance Ltd",
      description:
        "CHI Life Assurance Ltd offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "consolidated-hallmark",
      name: "Consolidated Hallmark Insurance Plc",
      description:
        "Consolidated Hallmark Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address:
        "266 Moshood Abiola Way (formerly Ikorodu Road), Obanikoro, Lagos",
      website: "www.ch-insure.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "coronation",
      name: "Coronation Insurance Ltd",
      description:
        "Coronation Insurance Ltd provides innovative insurance solutions including group life insurance with a customer-centric approach.",
      address: "No. 199, Awolowo Road, Ikoyi, Lagos",
      website: "www.coronation.ng/institus/coronation-insurance/",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "cornerstone",
      name: "Cornerstone Insurance Limited",
      description:
        "Cornerstone Insurance Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "21, Water Corporation Drive, Oniru, Victoria Island, Lagos",
      website: "www.cornerstone.com.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "crown-takaful",
      name: "Crown Takaful Insurance",
      description:
        "Crown Takaful Insurance offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "custodian-allied",
      name: "Custodian & Allied Insurance Ltd",
      description:
        "Custodian & Allied Insurance Ltd specializes in life insurance products including group life insurance with flexible coverage options.",
      address: "16A, Commercial Avenue, Sabo, Yaba, Lagos",
      website: "www.custodianplc.com.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "emple",
      name: "emPle General Insurance Company Nigeria Ltd",
      description:
        "emPle General Insurance Company Nigeria Ltd offers reliable group life insurance products tailored for employers.",
      address:
        "4th Floor, Plot 1297, Akin Adesola Street, Victoria Island, Lagos",
      website: "www.emple.group",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "enterprise-life",
      name: "Enterprise Life Assurance Co. Ltd",
      description:
        "Enterprise Life Assurance Co. Ltd offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "fin",
      name: "Fin Insurance Company Ltd",
      description:
        "Fin Insurance Company Ltd provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "No. 34 Gana Street, Maitama, FCT Abuja",
      website: "www.finsurance.com.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "fortis-global",
      name: "Fortis Global Insurance Plc",
      description:
        "Fortis Global Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "goldlink",
      name: "GoldLink Insurance Plc",
      description:
        "GoldLink Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "great-nigeria",
      name: "Great Nigeria Insurance Plc",
      description:
        "Great Nigeria Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "guinea",
      name: "Guinea Insurance Plc",
      description:
        "Guinea Insurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
      address: "No. 33, Ikorodu Road, Jibowu, Lagos",
      website: "www.guineainsurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "heirs",
      name: "Heirs Insurance Ltd",
      description:
        "Heirs Insurance Ltd provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
      address:
        "Heirs Insurance Towers, Plot 107B, Ajose Adeogun Street, Victoria Island, Lagos",
      website: "www.heirsinsurancegroup",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "igi",
      name: "Industrial and General Insurance Plc",
      description:
        "Industrial and General Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "IGI Plaza, 16 Idowu Taylor Street, Victoria Island, Lagos",
      website: "www.iginigeria.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "international-energy",
      name: "International Energy Insurance Plc",
      description:
        "International Energy Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address:
        "Plot 294, Jide Oki Street, off Ligali Ayorinde Street, Victoria Island, Lagos",
      website: "www.ieiplcng.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "jaiz-takaful",
      name: "Jaiz Takaful Insurance Ltd",
      description:
        "Jaiz Takaful Insurance Ltd offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "kbl",
      name: "KBL Insurance Ltd",
      description:
        "KBL Insurance Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
      address:
        "Block 138, Plot 5, Gabriel Olusanya Street, Lekki Phase 1, Lagos",
      website: "www.kblinsurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "lasaco",
      name: "Lasaco Assurance Plc",
      description:
        "Lasaco Assurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "LASACO House, Plot 44/48 Martins Street, Lagos",
      website: "www.lasacoassurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "linkage",
      name: "Linkage Assurance Plc",
      description:
        "Linkage Assurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address:
        "Linkage Plaza, Plot 20 Block 94, Lekki–Epe Expressway, Victoria Island, Lagos",
      website: "www.linkageassurance.co",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "leadway",
      name: "Leadway Assurance Company Limited",
      description:
        "Leadway Assurance Company Limited is one of Nigeria's foremost insurance service companies, providing life and non-life insurance solutions for individuals and businesses.",
      address: "121/123 Funso Williams Avenue, Iponri, Surulere, Lagos",
      website: "https://www.leadway.com/",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "mutual-benefits",
      name: "Mutual Benefits Assurance Plc",
      description:
        "Mutual Benefits Assurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
      address: "Aret Adams House, 233 Ikorodu Road, Ilupeju, Lagos",
      website: "www.mutualng.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "nem",
      name: "NEM Insurance Plc",
      description:
        "NEM Insurance Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "199 Ikorodu Road, Obanikoro, Lagos",
      website: "www.nem-insurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "nicon",
      name: "NICON Insurance Plc",
      description:
        "NICON Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "naic",
      name: "Nigerian Agricultural Insurance Corporation (NAIC)",
      description:
        "Nigerian Agricultural Insurance Corporation (NAIC) offers specialized insurance solutions including group life insurance.",
      address: "Plot 590, Zone A.O., Central Area, P.M.B. 0178, Abuja",
      website: "www.naic.gov.ng",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "noor-takaful",
      name: "Noor Takaful Insurance Limited",
      description:
        "Noor Takaful Insurance Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "npf",
      name: "NPF Insurance Co. Ltd",
      description:
        "NPF Insurance Co. Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
      address:
        "Behind Louis Edet House, Force Headquarters, Area 11, Garki, Abuja",
      website: "www.npfinsurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "nsia",
      name: "NSIA Insurance",
      description:
        "NSIA Insurance provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address:
        "Churchgate Tower II, PC 31 Churchgate Street, Victoria Island, Lagos",
      website: "www.nsiainsurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "phoenix-capital-express",
      name: "Phoenix Capital Express Services Limited",
      description:
        "Phoenix Capital Express Services Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "prestige",
      name: "Prestige Assurance Plc",
      description:
        "Prestige Assurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "19 Ligali Ayorinde Street, Victoria Island, Lagos",
      website: "www.prestigeassurancep",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "regency",
      name: "Regency Alliance Insurance Plc",
      description:
        "Regency Alliance Insurance Plc provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
      address: "2 Ebun Street, Gbagada Expressway, Gbagada, Lagos",
      website: "www.regencyalliance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "rex",
      name: "REX Insurance Ltd",
      description:
        "REX Insurance Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
      address:
        "26E Abdulrahman Okene Close, off Ligali Ayorinde Street, Victoria Island, Lagos",
      website: "www.rexinsure.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "royal-exchange-prudential",
      name: "Royal Exchange Prudential Life Plc",
      description:
        "Royal Exchange Prudential Life Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "salam-takaful",
      name: "Salam Takaful Insurance Limited",
      description:
        "Salam Takaful Insurance Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "sanlam",
      name: "Sanlam (Allianz General Insurance Nigeria Ltd)",
      description:
        "Sanlam (Allianz General Insurance Nigeria Ltd) provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "298 Ikorodu Road, Anthony, Lagos",
      website: "www.sanlam.com.ng/corp",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "sanlam-life",
      name: "Sanlam Life Insurance Nigeria Limited",
      description:
        "Sanlam Life Insurance Nigeria Limited offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "sovereign",
      name: "Sovereign Trust Insurance Plc",
      description:
        "Sovereign Trust Insurance Plc offers reliable group life insurance products with competitive rates and excellent customer service.",
      address: "17 Adetokunbo Ademola Street, Victoria Island, Lagos",
      website: "www.stiplc.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "staco",
      name: "Staco Insurance Plc",
      description:
        "Staco Insurance Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "209 Herbert Macaulay Street, Ebute Metta, Lagos",
      website: "www.portals.stacoplc.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "stanbic-ibtc-insurance",
      name: "Stanbic IBTC Insurance Limited",
      description:
        "Stanbic IBTC Insurance Limited provides solution-based risk management and claims services, helping clients create, protect, and preserve wealth through life insurance offerings.",
      address:
        "Stanbic IBTC Towers, Walter Carrington Crescent, Victoria Island, Lagos",
      website: "https://www.stanbicibtcinsurance.com/",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "sterling",
      name: "Sterling Assurance Nigeria Ltd",
      description:
        "Sterling Assurance Nigeria Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
      address: "Sterling House, 284 Ikorodu Road, Anthony, Lagos",
      website: "www.sterlingassure.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "sunu",
      name: "Sunu Assurances Plc",
      description:
        "Sunu Assurances Plc provides comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "Plot 1196, Bishop Oluwole Street, Victoria Island, Lagos",
      website: "www.sunuassurancesnige",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "tangerine",
      name: "Tangerine General Insurance Ltd",
      description:
        "Tangerine General Insurance Ltd offers innovative insurance solutions including group life insurance with comprehensive coverage options.",
      address: "House 14, Hughes Avenue, Alagbomeji, Yaba, Lagos",
      website: "www.general.tangerine.af",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "unitrust",
      name: "Unitrust Insurance Nigeria Ltd",
      description:
        "Unitrust Insurance Nigeria Ltd provides reliable group life insurance products with competitive rates and excellent customer service.",
      address: "Plot 105B, Ajose Adeogun Street, Victoria Island, Lagos",
      website: "www.unitrustinsurance.co",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "universal",
      name: "Universal Insurance Plc",
      description:
        "Universal Insurance Plc offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "No. 11A, Ligali Ayorinde Street, Victoria Island, Lagos",
      website: "www.universalinsurancep",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "veritas",
      name: "Veritas Kapital Assurance Plc",
      description:
        "Veritas Kapital Assurance Plc provides innovative insurance solutions including group life insurance with comprehensive coverage options.",
      address:
        "Plot 497, Abogo Largema Street, off Constitution Avenue, CBD, Abuja",
      website: "www.veritaskapital.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "zenith",
      name: "Zenith General Insurance Company Ltd",
      description:
        "Zenith General Insurance Company Ltd offers reliable group life insurance products with competitive rates and excellent customer service.",
      address: "Plot 280, Ajose Adeogun Street, Victoria Island, Lagos",
      website: "www.zenithinsurance.com",
      icon: "/assets/icons/building.svg",
    },
    {
      id: "zenith-prudential-life",
      name: "Zenith Prudential Life Insurance",
      description:
        "Zenith Prudential Life Insurance offers comprehensive group life insurance solutions designed to protect employees and their families.",
      address: "",
      website: "",
      icon: "/assets/icons/building.svg",
    },
  ],
  AUTHORIZED_CONTACT_PREFERRED_CHANNELS: [
    {
      id: "Email",
      name: "Email",
    },
  ],
  AUTHORIZED_CONTACT_ROLES: [
    "Managing Director / CEO",
    "HR Manager",
    "Payroll Officer / Accountant",
    "Compliance Officer",
    "Company Secretary / Legal Officer",
  ],

  PCC_CHECKLIST: [
    "Contribution is up to date",
    "Active and Approved Group life Insurance",
    // "No Penalties ",
    // "Uploaded and Verified CAC Document",
  ],
  PCC_CHECKLIST_STATUS: {
    GLI_NOT_FOUND: "GLI_NOT_FOUND",
    CONTRIBUTIONS_INCOMPLETE: "CONTRIBUTIONS_INCOMPLETE",
    CONTRIBUTIONS_EMPLOYEE_COUNT_MISMATCH:
      "CONTRIBUTIONS_EMPLOYEE_COUNT_MISMATCH",
    GLI_COVERAGE_MISMATCH: "GLI_COVERAGE_MISMATCH",
    GLI_EXPIRING_SOON: "GLI_EXPIRING_SOON",
    GLI_EXPIRED: "GLI_EXPIRED",
    NO_CONTRIBUTIONS: "NO_CONTRIBUTIONS",
    EMPLOYEE_COUNT_BELOW_MINIMUM: "EMPLOYEE_COUNT_BELOW_MINIMUM",
    OUTSTANDING_PENALTY: "OUTSTANDING_PENALTY",
    INCORPORATION_TOO_RECENT: "INCORPORATION_TOO_RECENT",
  },

  CERTIFICATE_DISCLAIMER_VERSION: "1.0",
  CERTIFICATE_DISCLAIMER_TEXT: [
    "Employers are advised to carefully review their certificate upon issuance. " +
      "Any errors or discrepancies should be reported to the Commission within one " +
      "(1) week of issuance.",
    "The Commission shall not be held liable for any errors reported after this period.",
  ],
  /** Block the download when the acknowledgment POST fails. Set to false to allow download on ack failure. */
  CERTIFICATE_DISCLAIMER_FAIL_CLOSED: true,
  /** Days before the disclaimer dialog is shown again after acknowledgment. */
  CERTIFICATE_DISCLAIMER_SUPPRESS_DAYS: 7,
};
